import React from "react";
import { WeatherIconProps } from "./types";
import { Weather } from "../../types/variables/Variables";
import { cloudy, fair, light_rain, partly_cloud, sleet } from '../../assets/images/forecast'

export const SimpleWeatherIcon: React.FC<WeatherIconProps> = ({ weather }) => {
    switch (weather?.toLowerCase()) {
        case Weather.SUNNY:
            return <img src={sleet} />;

        case Weather.CLOUDY:
            return <img src={cloudy} />;

        case Weather.RAINY:
            return <img src={light_rain} />;

        case "stormy":
        case "thunderstorm":
            return <img src={fair} />;

        case "haze":
        case "fog":
        case "smog":
            return <img src={partly_cloud} />;

        default:
            return <img src={sleet} />;
    }
};
